import React, { useEffect, useState, useCallback } from 'react';

const MouseTracker = () => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [isMoving, setIsMoving] = useState(false);

  const handleMouseMove = useCallback((e) => {
    setMousePosition({ x: e.clientX, y: e.clientY });
    setIsMoving(true);
  }, []);

  useEffect(() => {
    let timeout;
    let animationId;
    
    const throttledMouseMove = (e) => {
      if (animationId) return;
      
      animationId = requestAnimationFrame(() => {
        handleMouseMove(e);
        animationId = null;
        
        clearTimeout(timeout);
        timeout = setTimeout(() => setIsMoving(false), 100);
      });
    };

    window.addEventListener('mousemove', throttledMouseMove, { passive: true });
    return () => {
      window.removeEventListener('mousemove', throttledMouseMove);
      if (timeout) clearTimeout(timeout);
      if (animationId) cancelAnimationFrame(animationId);
    };
  }, [handleMouseMove]);

  return (
    <>
      <div 
        className="cursor-main"
        style={{
          left: mousePosition.x,
          top: mousePosition.y,
          transform: `translate(-50%, -50%) scale(${isMoving ? 1.2 : 1})`,
          transition: 'transform 0.1s ease'
        }}
      />
      
      <div 
        className="cursor-trail"
        style={{
          left: mousePosition.x,
          top: mousePosition.y,
          transform: `translate(-50%, -50%) scale(${isMoving ? 0.8 : 1})`,
          transition: 'transform 0.2s ease'
        }}
      />
      
      <div 
        className="cursor-glow"
        style={{
          left: mousePosition.x,
          top: mousePosition.y,
          transform: `translate(-50%, -50%) scale(${isMoving ? 2 : 1.5})`,
          transition: 'transform 0.3s ease'
        }}
      />
    </>
  );
};

export default MouseTracker;